import React from 'react'
import PropTypes from 'prop-types'

import { DrawerContent } from './DrawerContent'
import { DrawerHeader } from './DrawerHeader'
import { DrawerBody } from './DrawerBody'
import { DrawerFooter } from './DrawerFooter'
import { DrawerActions } from './DrawerActions'
import { DrawerTitle } from './DrawerTitle'
import { DrawerTitleIcon } from './DrawerTitleIcon'

export const Drawer = (props) => {
  const {
    size,
    onClose: onRequestClose,
    ...restProps
  } = props

  return (
    <DrawerContent
      position='fixed'
      height='100%'
      width='500px'
      top='50px'
      right='0'
      {...restProps}
    />
  )
}

Drawer.Body = DrawerBody
Drawer.Footer = DrawerFooter
Drawer.Header = DrawerHeader
Drawer.Actions = DrawerActions
Drawer.Title = DrawerTitle
Drawer.TitleIcon = DrawerTitleIcon

Drawer.defaultProps = {
  isOpen: false,
}

Drawer.propTypes = {
  children: PropTypes.node,
  contentComponent: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  overlayComponent: PropTypes.func,
  size: PropTypes.string,
}
